import React from 'react';
import PropTypes from 'prop-types';
import TabItemsImage from '../tabItemsImage/tabItemsImage';
import TabItemsContent from '../tabItemsContent/tabItemsContent';
import styles from './tabItems.module.scss';

function TabItems({ content, image, cta, tokenKey }) {
  return (
    <div className={styles.panelWrapper}>
      <TabItemsImage {...image} />
      <TabItemsContent content={content} cta={cta} tokenKey={tokenKey} />
    </div>
  );
}

TabItems.propTypes = {
  content: PropTypes.any.isRequired,
  image: PropTypes.any.isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  tokenKey: PropTypes.string,
};

export default TabItems;
